import { render, staticRenderFns } from "./purchaserVisitListTable.vue?vue&type=template&id=51991bc8&scoped=true"
import script from "./purchaserVisitListTable.vue?vue&type=script&lang=js"
export * from "./purchaserVisitListTable.vue?vue&type=script&lang=js"
import style0 from "./purchaserVisitListTable.vue?vue&type=style&index=0&id=51991bc8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51991bc8",
  null
  
)

export default component.exports